<template>
  <Grid
    :resizable="true"
    :reorderable="true"
    :row-height="25"
    :data-items="items"
    :columns="prepareColumnsData({ initialColumns: fields, settingsColumns: gridSettings.columns })"
    @columnresize="handleColumnResize"
    @columnreorder="handleColumnReorder"
    class="grid mt-2"
  >
    <template v-slot:commands="{props}">
      <td>
        <b-button
          size="sm"
          class="btn btn-primary"
          variant="primary"
          @click="onEdit(props.dataItem)"
        >
          <i class="fa fa-edit"></i>
        </b-button>
        <b-button size="sm" variant="danger" @click="onDelete(props.dataItem)">
          <i class="fa fa-trash"></i>
        </b-button>
      </td>
    </template>

    <template v-slot:expiry="{props}">
      <td>{{props.dataItem.expYear}}/{{props.dataItem.expMonth}}</td>
    </template>
  </Grid>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import debounce from 'lodash/debounce';

import { GRID_ID, SAVE_SETTINGS_DELAY } from '@/shared/constants';
import { prepareColumnsData } from '@/shared/helpers';

import fields from '../../fields';

export default {
  props: {
    items: Array,
    onEdit: Function,
    onDelete: Function,
  },
  data: () => ({
    fields,
    prepareColumnsData,
  }),
  computed: {
    ...mapGetters('account', ['gridSettingsById']),
    gridSettings() {
      return this.gridSettingsById(GRID_ID.COMPANY_CREDIT_CARDS);
    },
  },
  methods: {
    ...mapActions('account', ['saveGridSettings']),
    handleColumnResize: debounce(function({ columns }) {
      const newColumns = prepareColumnsData({
        columns,
        initialColumns: fields,
        settingsColumns: this.gridSettings.columns,
      });

      this.saveGridSettings({
        id: GRID_ID.COMPANY_CREDIT_CARDS,
        settings: { columns: newColumns },
      });
    }, SAVE_SETTINGS_DELAY),
    handleColumnReorder({ columns }) {
      const newColumns = prepareColumnsData({
        columns,
        initialColumns: fields,
        settingsColumns: this.gridSettings.columns,
      });

      this.saveGridSettings({
        id: GRID_ID.COMPANY_CREDIT_CARDS,
        settings: { columns: newColumns },
      });
    },
  },
};
</script>
